document.addEventListener('DOMContentLoaded', function() {
  // Target the female vertical quantity selector
  const verticalSelector = document.querySelector('.vertical-quantity-selector-female');
  const addToCartButton = document.querySelector('.product-form__submit');
  
  if (!verticalSelector || !addToCartButton) return;

  // Get main product form
  const productForm = document.querySelector('.product-form form');
  if (!productForm) return;

  // Get combination data
  let combinationData = null;
  const combinationDataElement = document.getElementById('VerticalCombinationDataFemale');
  if (combinationDataElement) {
    try {
      combinationData = JSON.parse(combinationDataElement.textContent);
    } catch (e) {
      console.error('❌ VERTICAL-FEMALE: Failed to parse combination data', e);
      return;
    }
  } else {
    console.error('❌ VERTICAL-FEMALE: No combination data found');
    return;
  }

  // Get all radio buttons
  const quantityRadios = verticalSelector.querySelectorAll('.quantity-radio');
  const hiddenInput = document.getElementById('vertical-quantity-value');

  // Main price elements (outside the selector)
  const mainPriceContainer = document.querySelector('.price__container');
  const mainPriceRegular = mainPriceContainer ? mainPriceContainer.querySelector('.price__regular .price-item') : null;
  const mainPriceSale = mainPriceContainer ? mainPriceContainer.querySelector('.price__sale .price-item--sale') : null;
  const mainPriceCompare = mainPriceContainer ? mainPriceContainer.querySelector('.price__sale .price-item--regular') : null;

  // Track selected ebook choices
  let selectedEbookChoices = {};
  let lastSelectedEbookHandle = null;
  const PREFERRED_FREE_EBOOK_HANDLE = 'e-book-2-free'; // Preferred default

  // Use Shopify's money formatting for proper market-adjusted currency display
  function formatCurrency(cents) {
    // Helper to format money locally to avoid external overrides
    function formatMoney(cents, format) {
      if (typeof cents === 'string') { cents = cents.replace('.', ''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || (window.Shopify ? window.Shopify.money_format : '{{amount_with_comma_separator}} €'));
      
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';
        
        if (isNaN(number) || number == null) { return 0; }
        
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';
        
        return dollars + cents;
      }
      
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
      }
      
      return formatString.replace(placeholderRegex, value);
    }

    // Get the market-specific format and adjust it to put currency symbol after the amount with no space
    let format = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : '{{amount_with_comma_separator}} €';
    
    // Move currency symbol to the end: handles "€ {{amount}}", "CHF {{amount}}", etc.
    const match = format.match(/^(.*?)(\{\{[^}]+\}\})(.*)$/);
    if (match) {
      const prefix = match[1].trim();
      const placeholder = match[2];
      const suffix = match[3].trim();
      // If currency is at the start, move it to the end
      if (prefix && !suffix) {
        format = placeholder + prefix;
      } else if (suffix) {
        format = placeholder + suffix;
      } else {
        format = placeholder;
      }
    }
    
    var result = formatMoney(cents, format);
    // Remove .00 or ,00 if present for round prices
    result = result.replace(/[.,]00(?!\d)/g, '');
    return result;
  }

  function getTotalsForQuantity(quantityValue) {
    if (!combinationData || !combinationData.combinations) return null;
    const comboKey = `combo-${quantityValue}-false`;
    const combination = combinationData.combinations[comboKey];
    if (!combination || !Array.isArray(combination.products)) return null;
    
    let currentTotal = 0, originalTotal = 0;
    combination.products.forEach((product, index) => {
      if (product && product.is_choice_ebook && Array.isArray(product.choice_options) && product.choice_options.length > 0) {
        const choiceId = product.choice_id || `choice-${index}`;
        let selectedOption = null;
        
        // Try to find selection in this order:
        // 1. Last selected handle (if valid for this choice)
        // 2. Current selection for this specific choiceId
        // 3. First available option
        
        if (lastSelectedEbookHandle && product.choice_options.some(opt => opt.handle === lastSelectedEbookHandle)) {
          selectedOption = product.choice_options.find(opt => opt.handle === lastSelectedEbookHandle);
        }
        if (!selectedOption) {
          const presetHandle = selectedEbookChoices[choiceId];
          if (presetHandle && product.choice_options.some(opt => opt.handle === presetHandle)) {
            selectedOption = product.choice_options.find(opt => opt.handle === presetHandle);
          }
        }
        if (!selectedOption) selectedOption = product.choice_options[0];

        // Ebooks are free in this context
        currentTotal += 0; 
        originalTotal += 0; // Do not add ebook price to compare price
      } else if (product) {
        const isGiftCard10Euro = product.title && product.title.toLowerCase().includes('10') && product.title.toLowerCase().includes('gutschein');
        if (isGiftCard10Euro) { 
          currentTotal += 0; 
          originalTotal += 0; // Gift card shown as free
        } else { 
          currentTotal += product.current_price || 0; 
          originalTotal += product.original_price || product.current_price || 0; 
        }
      }
    });
    return { current_total: currentTotal, original_total: originalTotal, savings: originalTotal - currentTotal };
  }

  function generateBundleGroupId() {
    return 'b-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function buildCartItems(combination, comboKey) {
    const items = [];
    const mainProduct = combination && Array.isArray(combination.products) ? combination.products[0] : null;
    const mainVariantId = mainProduct && mainProduct.id ? mainProduct.id : null;
    const bundleGroupId = generateBundleGroupId();

    combination.products.forEach((product, index) => {
      if (!product || !product.id) return;
      
      const lowerTitle = (product.title || '').toLowerCase();
      const handle = product.handle || '';
      const isMainRow = index === 0;
      const isGift = /gutschein/.test(lowerTitle) || handle === '10-geschenk-gutschein' || handle === '15-geschenk-gutschein';
      const isTea = handle === 'unser-lieblings-tee' || /tee/.test(lowerTitle);

      let itemToAdd;
      if (product.is_choice_ebook) {
        const choiceId = product.choice_id || `choice-${index}`;
        const selectedHandle = selectedEbookChoices[choiceId] || product.choice_options[0].handle;
        const selectedOption = product.choice_options.find(opt => opt.handle === selectedHandle) || product.choice_options[0];
        
        if (!selectedOption || !selectedOption.id) {
          console.warn('No valid ebook option found for', choiceId);
          return;
        }

        itemToAdd = {
          id: selectedOption.id,
          quantity: 1,
          properties: {
            _bundle_group: bundleGroupId,
            _bundle_dep: '1',
            _bundle_type: 'ebook',
            _parent_variant: mainVariantId || '',
            _combo_key: comboKey || ''
          }
        };
      } else {
        itemToAdd = {
          id: product.id,
          quantity: 1,
          properties: isMainRow ? {
            _bundle_group: bundleGroupId,
            _bundle_main: '1',
            _combo_key: comboKey || ''
          } : {
            _bundle_group: bundleGroupId,
            _bundle_dep: '1',
            _bundle_type: isGift ? 'gift' : (isTea ? 'addon' : 'addon'),
            _parent_variant: mainVariantId || '',
            _combo_key: comboKey || ''
          }
        };
      }
      items.push(itemToAdd);
    });

    console.log('✅ VERTICAL-FEMALE: Built cart items:', items);
    return items;
  }

  // --- Ebook Dropdown Logic ---

  function renderEbookDropdowns(quantityValue) {
    const comboKey = `combo-${quantityValue}-false`;
    const combination = combinationData.combinations[comboKey];
    if (!combination) return;

    // Find all ebook containers for this quantity
    const quantityBox = verticalSelector.querySelector(`.quantity-option-box[data-quantity="${quantityValue}"]`);
    if (!quantityBox) return;

    const containers = quantityBox.querySelectorAll('.ebook-selection-container');
    if (containers.length === 0) return;

    // Get ebook products in this combo
    const ebookProducts = combination.products.filter(p => p.is_choice_ebook);
    
    // Resolve Selections (Mutual Exclusion)
    const ebookDropdownsInThisCombo = [];
    const alreadySelected = new Set();

    ebookProducts.forEach((product, i) => {
      const choiceId = product.choice_id || `choice-${i}`;
      ebookDropdownsInThisCombo.push({ choiceId, product, container: containers[i] });
    });

    // Remove stale selections
    const activeChoiceIds = new Set(ebookDropdownsInThisCombo.map(entry => entry.choiceId));
    Object.keys(selectedEbookChoices).forEach(choiceId => {
      if (!activeChoiceIds.has(choiceId)) {
        delete selectedEbookChoices[choiceId];
      }
    });

    // Pick options
    const pickOptionHandle = (product, preferredHandle) => {
      // 1. Preferred/Current
      if (preferredHandle && product.choice_options.some(opt => opt.handle === preferredHandle) && !alreadySelected.has(preferredHandle)) {
        return preferredHandle;
      }
      // 2. Default Free Handle
      if (product.choice_options.some(opt => opt.handle === PREFERRED_FREE_EBOOK_HANDLE) && !alreadySelected.has(PREFERRED_FREE_EBOOK_HANDLE)) {
        return PREFERRED_FREE_EBOOK_HANDLE;
      }
      // 3. First Available
      const available = product.choice_options.find(opt => !alreadySelected.has(opt.handle));
      if (available) return available.handle;
      
      return product.choice_options[0].handle;
    };

    ebookDropdownsInThisCombo.forEach(({ choiceId, product }) => {
      const preferredHandle = selectedEbookChoices[choiceId] || lastSelectedEbookHandle;
      const assignedHandle = pickOptionHandle(product, preferredHandle);
      selectedEbookChoices[choiceId] = assignedHandle;
      alreadySelected.add(assignedHandle);
    });

    // Render Dropdowns
    ebookDropdownsInThisCombo.forEach(({ choiceId, product, container }) => {
      if (!container) return;

      const currentChoice = selectedEbookChoices[choiceId];
      const otherSelectedHandles = Object.entries(selectedEbookChoices)
        .filter(([id, handle]) => id !== choiceId && activeChoiceIds.has(id))
        .map(([, handle]) => handle);

      let optionsHTML = '';
      product.choice_options.forEach(option => {
        const isCurrentSelection = option.handle === currentChoice;
        const isSelectedElsewhere = otherSelectedHandles.includes(option.handle);

        if (isCurrentSelection || !isSelectedElsewhere) {
           optionsHTML += `<option value="${option.handle}" ${isCurrentSelection ? 'selected' : ''}>E-Book: ${option.title}</option>`;
        }
      });

      container.innerHTML = `
        <select class="ebook-dropdown" data-choice-id="${choiceId}">
          ${optionsHTML}
        </select>
        <span class="gratis-label">Gratis</span>
      `;

      // Attach listener
      const select = container.querySelector('select');
      select.addEventListener('change', function(e) {
        selectedEbookChoices[choiceId] = e.target.value;
        lastSelectedEbookHandle = e.target.value;
        // Re-render to update exclusions
        renderEbookDropdowns(quantityValue);
      });
    });
  }

  // --- Price & UI Update Logic ---

  function updatePrices(quantityValue) {
    const comboKey = `combo-${quantityValue}-false`;
    const combination = combinationData.combinations[comboKey];
    
    if (!combination) {
      console.error('❌ VERTICAL-FEMALE: No combination found for', comboKey);
      return;
    }

    const mainProduct = combination.products[0];
    const totals = getTotalsForQuantity(quantityValue);

    const quantityTitleMap = {
      '1': '1 x 60 Shilajit Tabs',
      '2': '3 x 60 Shilajit Tabs',
      '3': '6 x 60 Shilajit Tabs'
    };
    
    const gratisTextMap = {
      '2': 'Kauf 2, Erhalte 1 GRATIS'
    };

    const quantityBox = verticalSelector.querySelector(`.quantity-option-box[data-quantity="${quantityValue}"]`);
    if (quantityBox) {
      const titleEl = quantityBox.querySelector('.variant-title');
      const comparePriceEl = quantityBox.querySelector('[data-compare-price]');
      const currentPriceEl = quantityBox.querySelector('[data-current-price]');
      const pricePerPackEl = quantityBox.querySelector('[data-price-per-pack]');
      const gratisTagEl = quantityBox.querySelector('[data-gratis-tag]');

      if (titleEl && quantityTitleMap[quantityValue]) {
        titleEl.innerHTML = quantityTitleMap[quantityValue];
      }
      
      if (gratisTagEl) {
        if (gratisTextMap[quantityValue]) {
          gratisTagEl.textContent = gratisTextMap[quantityValue];
          gratisTagEl.style.display = 'inline-block';
        } else {
          gratisTagEl.style.display = 'none';
        }
      }
      
      if (currentPriceEl) {
        currentPriceEl.textContent = formatCurrency(totals.current_total);
      }

      if (comparePriceEl) {
        if (totals.original_total > totals.current_total) {
          comparePriceEl.textContent = formatCurrency(totals.original_total);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.style.display = 'none';
        }
      }

      if (pricePerPackEl) {
        let packCount = 1;
        let pricePerPack = totals.current_total;

        if (quantityValue === '1') {
          packCount = 1;
          pricePerPack = totals.current_total;
        } else if (quantityValue === '2') {
          packCount = 3;
          pricePerPack = Math.round(totals.current_total / 3);
        } else if (quantityValue === '3') {
          packCount = 6;
          pricePerPack = Math.round(totals.current_total / 6);
        }

        pricePerPackEl.textContent = `${formatCurrency(pricePerPack)} / Packung`;
      }

      const savingsBadgeEl = quantityBox.querySelector('[data-savings-badge]');
      if (savingsBadgeEl && totals.savings > 0) {
        savingsBadgeEl.textContent = `Du sparst ${formatCurrency(totals.savings)}`;
        savingsBadgeEl.style.display = 'inline-block';
      } else if (savingsBadgeEl) {
        savingsBadgeEl.style.display = 'none';
      }
    }

    updateMainPrice(mainProduct, totals, quantityValue);
    updateMainProductVariantId(mainProduct);
  }

  function updateAllPrices() {
    ['1', '2', '3'].forEach(quantity => {
      updatePrices(quantity);
      renderEbookDropdowns(quantity); // Render dropdowns for all visible boxes
    });
  }

  function updateMainPrice(mainProduct, totals, quantityValue) {
    if (!mainPriceContainer || !mainPriceSale || !mainPriceCompare || !mainPriceRegular) return;

    const finalPriceText = formatCurrency(totals.current_total);
    const actualCompareAtPrice = mainProduct.original_price;
    const actualCurrentPrice = mainProduct.current_price;
    const hasCompareAtPrice = actualCompareAtPrice && actualCompareAtPrice > actualCurrentPrice;

    if (hasCompareAtPrice) {
      mainPriceContainer.classList.add('price--on-sale');
      mainPriceSale.textContent = finalPriceText;
      mainPriceCompare.textContent = formatCurrency(actualCompareAtPrice);
    } else {
      mainPriceContainer.classList.remove('price--on-sale');
      mainPriceRegular.textContent = finalPriceText;
      mainPriceCompare.textContent = '';
    }

    const buttonPriceElement = addToCartButton ? addToCartButton.querySelector('[data-atc-price]') : null;
    if (buttonPriceElement && verticalSelector) {
      const selectedRadio = verticalSelector.querySelector('.quantity-radio:checked');
      const selectedQuantity = selectedRadio ? selectedRadio.value : null;
      if (selectedQuantity) {
        const quantityBox = verticalSelector.querySelector(`.quantity-option-box[data-quantity="${selectedQuantity}"]`);
        if (quantityBox) {
          const currentPriceEl = quantityBox.querySelector('[data-current-price]');
          if (currentPriceEl && currentPriceEl.textContent.trim()) {
            buttonPriceElement.textContent = currentPriceEl.textContent.trim();
          }
        }
      }
    }
  }

  function updateMainProductVariantId(mainProduct) {
    if (mainProduct && mainProduct.id) {
      const mainProductFormIdInput = document.querySelector('product-form form [name=id]');
      if (mainProductFormIdInput) {
        mainProductFormIdInput.value = mainProduct.id;
        mainProductFormIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function handleQuantityChange(quantityValue) {
    console.log('✅ VERTICAL-FEMALE: Quantity changed to', quantityValue);
    
    if (hiddenInput) {
      hiddenInput.value = quantityValue;
    }

    updatePrices(quantityValue);
  }

  // Add event listeners to radio buttons
  quantityRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        handleQuantityChange(this.value);
      }
    });
  });

  // Initialize
  updateAllPrices();

  // Set initial selection (quantity 2)
  const initialQuantity = '2';
  const initialRadio = verticalSelector.querySelector(`.quantity-radio[value="${initialQuantity}"]`);
  if (initialRadio) {
    initialRadio.checked = true;
    handleQuantityChange(initialQuantity);
  }

  // Override form submit
  const originalSubmitHandler = productForm.onsubmit;
  productForm.onsubmit = function(event) {
    event.preventDefault();

    const selectedRadio = verticalSelector.querySelector('.quantity-radio:checked');
    const selectedQuantity = selectedRadio ? selectedRadio.value : '2';
    const comboKey = `combo-${selectedQuantity}-false`;

    console.log('✅ VERTICAL-FEMALE: Adding to cart with quantity', selectedQuantity);

    const combination = combinationData.combinations[comboKey];
    if (!combination) {
      console.error('❌ VERTICAL-FEMALE: No combination found for key:', comboKey);
      return;
    }

    let items = buildCartItems(combination, comboKey);

    if (items.length === 0) {
      console.error('❌ VERTICAL-FEMALE: No cart items built');
      return;
    }

    addToCartButton.classList.add('loading');

    const cartDrawerElement = document.querySelector('cart-drawer');
    let sectionsToRequest = [];
    let defaultSections = [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];

    if (cartDrawerElement && typeof cartDrawerElement.getSectionsToRender === 'function') {
      try {
        sectionsToRequest = cartDrawerElement.getSectionsToRender().map(s => s.id);
        if (sectionsToRequest.length === 0) sectionsToRequest = defaultSections.map(s => s.id);
      } catch (e) {
        sectionsToRequest = defaultSections.map(s => s.id);
      }
    } else {
      sectionsToRequest = defaultSections.map(s => s.id);
    }

    const sectionsUrl = window.location.pathname;
    const requestBody = {
      items,
      sections: sectionsToRequest,
      sections_url: sectionsUrl
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    })
      .then(response => response.json())
      .then(async (data) => {
        addToCartButton.classList.remove('loading');
        
        let validatedCart = data;
        const originalSections = data.sections;

        if (typeof validateCartRules === 'function') {
          try {
            validatedCart = await validateCartRules(data);
            if (originalSections && !validatedCart.sections) validatedCart.sections = originalSections;
          } catch (error) {
            if (originalSections && !validatedCart.sections) validatedCart.sections = originalSections;
          }
        }

        if (validatedCart.status) {
          console.error('❌ VERTICAL-FEMALE: Cart validation failed:', validatedCart);
          const errorMessage = document.querySelector('.product-form__error-message');
          const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
          if (errorMessage && errorWrapper) {
            const errorText = validatedCart.description || validatedCart.message || 'Could not add to cart. Please try again.';
            errorMessage.textContent = errorText;
            errorWrapper.removeAttribute('hidden');
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'vertical-quantity-selector-female',
              productVariantId: items.map(item => item.id).join(','),
              errors: validatedCart.errors || validatedCart.description,
              message: validatedCart.message
            });
          }
        } else {
          console.log('✅ VERTICAL-FEMALE: Cart validation successful');
          document.dispatchEvent(new Event('product:added'));
          
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'vertical-quantity-selector-female',
              productVariantId: items.map(item => item.id).join(','),
              cartData: validatedCart
            });
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(validatedCart);
          }

          const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
          if (errorWrapper && !errorWrapper.hasAttribute('hidden')) {
            errorWrapper.setAttribute('hidden', 'true');
          }
        }
      })
      .catch(error => {
        console.error('❌ VERTICAL-FEMALE: Fetch error occurred:', error);
        addToCartButton.classList.remove('loading');
        
        const errorMessage = document.querySelector('.product-form__error-message');
        const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
        if (errorMessage && errorWrapper) {
          errorMessage.textContent = 'An error occurred. Please try again.';
          errorWrapper.removeAttribute('hidden');
        }
      });
  };

  console.log('✅ VERTICAL-FEMALE: Initialized successfully');
});

